import React from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Text } from 'atoms';
import { makeAllBillBack } from 'store/invoiceSlice';

const MakeBillBackBtn = styled.div`
	height: 32px;
	margin-top: 1rem;
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.YellowOrange};
	color: ${(props) => props.theme.colors.OnyxS};
	line-height: 32px;
	text-align: center;
	font-size: 12px;
	cursor: pointer;
`;

export default function MakeAllBillBack({ visible, hide }) {
	const dispatch = useDispatch();

	function handleAllBillBack() {
		dispatch(makeAllBillBack()).then(() => {
			hide();
		});
	}

	return (
		<Modal footer={null} visible={visible} onCancel={hide} width={300}>
			<Text textAlign="center" fontSize="12px">
				Still there are pending invoices !
			</Text>
			<Text textAlign="center" fontSize="12px" pt="1rem">
				Do you want to
			</Text>
			<MakeBillBackBtn onClick={handleAllBillBack}>
				Make today pending invoices as Invoice Returned
			</MakeBillBackBtn>
		</Modal>
	);
}

MakeAllBillBack.propTypes = {
	visible: PropTypes.bool,
	hide: PropTypes.func.isRequired,
};
